import { debounce } from 'lodash';
import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setAccessControlDevice,
  updateProps,
} from '../../../contextRedux/AccessControlDevice/AccessControlDeviceModel';
import { SearchInput } from '../../../customComponents/input/SearchInput';
import { CustomTable } from '../../../customComponents/table/CustomTable';
import { RootState } from '../../../store';
import { AccessControlDeviceColumn } from './AccessControlDeviceColumn';

const AccessControlDeviceTable: FC<any> = () => {
  const dispatch = useDispatch();

  const reduxAccessControlDevice = useSelector((state: RootState) => state.models?.accessControlDevice);
  const accessControlDevices = useSelector((state: RootState) => state.store?.accessControlDevice.data ?? []);

  const pageSizes = [10, 20, 30, 50];
  const currentPage = Math.floor(reduxAccessControlDevice.props.skip / reduxAccessControlDevice.props.take) + 1;

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      dispatch(updateProps({ field: 'searchTerm', value }));
      dispatch(updateProps({ field: 'skip', value: 0 }));
    }, 500),
    [dispatch]
  );

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value);
  };

  const handleEdit = (record: any) => {
    dispatch(setAccessControlDevice(record));
    dispatch(updateProps({ field: 'isModalVisible', value: true }));
  };
  const paginationConfig = {
    current: currentPage,
    pageSize: reduxAccessControlDevice.props.take,
    total: reduxAccessControlDevice.props.totalItems,
    onChange: (page: number, pageSize: number) => {
      const skipValue = (page - 1) * pageSize;
      dispatch(updateProps({ field: 'skip', value: skipValue }));
      dispatch(updateProps({ field: 'take', value: pageSize }));
    },
    showSizeChanger: true,
    pageSizeOptions: pageSizes.map((size) => size.toString()),
    onShowSizeChange: (_current: number, size: number) => {
      dispatch(updateProps({ field: 'skip', value: 0 }));
      dispatch(updateProps({ field: 'take', value: size }));
    },
    showQuickJumper: false,
  };

  return (
    <>
      <SearchInput
        placeholder='Search...'
        defaultValue={reduxAccessControlDevice.props.searchTerm}
        onChange={handleSearch}
        style={{ marginBottom: 10 }}
      />
      <CustomTable
        initialDataSource={accessControlDevices}
        pagination={paginationConfig}
        columns={AccessControlDeviceColumn(handleEdit)}
        rowKey='id'
      />
    </>
  );
};

export default AccessControlDeviceTable;
